import BaseModel from '../core/BaseModel'
import UserModel from '@/models/UserModel'
export default class PaymentHistoryOrderModelPaymentHistoryOrderModel extends BaseModel {
    constructor() {
        super({
                name: "payment_history_order",
                tableName: 'payment_history',
                label: "Need to pay",
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Code ID',
                    //filter: {type: 'input', match: 'contains'},
                    width : 8,
                    class: "left",
                },
                description: {
                    name: 'description',
                    type: "String",
                    label: 'Description',
                    //filter: {type: 'input', match: 'contains'},
                    width : 8,
                    class: "left",
                },
                amount: {
                    name: 'amount',
                    type: "Numeric",
                    label: 'Amount',
                    width : 8,
                    class: "left",
                },
                status: {
                    name: "status",
                    label: "Status",
                    class: "left",
                    width : 15,

                },
                payment_method: {
                    name: "payment_method",
                    label: "Payment method",
                    // type: "Selection",
                    // custom: 'SelectionText',
                    options: [
                        {value: 'Other', label: 'Other'},
                        {value: 'Square', label: 'Online'},
                        {value: '-', label: '-'},
                    ],
                    // filter: {
                    //     type: 'select',
                    //     optionLabel: 'label',
                    //     optionKey: 'value',
                    //     match: 'equals'
                    // },
                    class: "left",
                    width : 8,

                },
                deletion_reason: {
                    name: 'deletion_reason',
                    type: "String",
                    label: 'Deletion reason',
                    // filter: {type: 'input', match: 'contains'},
                    class: "left",
                    width : 8,

                },
                total_payment: {
                    name: 'total_payment',
                    type: "String",
                    label: 'Total weekly kilometers',
                    width : 8,
                    class: "left",
                },
              
                created_at: {
                    name: 'created_at',
                    // type: "Datetime",
                    label: 'Created date',
                    // filter: {type: 'DateRange', match: 'contains'},
                    width : 8,
                    class: "left",
                },
                updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    // filter: {type: 'input', match: 'contains'},
                    models: new UserModel(),
                    computed: (data) => {
                        data.updated_by_key ='' ;
                    },
                    class:"left",
                    width : 8,
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Custom",
                    label: 'Updated date',
                    class:"left",
                    // filter: {type: 'DateRange', match: 'contains'},
                    width : 10,

                },
                detail_get: {
                    refs: 'obj_updated_by { id fullname } obj_rental_order { id code }',
                    display: false
                },
                detail_get1: {
                    refs: 'late_fee type obj_id',
                    display: false
                },
            })
    }
}
